import { Autocomplete, MenuItem, TextField } from "@mui/material";
import React, { useCallback, useState } from "react";
import {
  CURRENCY_LIST,
  formatCurrencyLabel,
  getCurrencyByCode,
  getCurrencySearchFields,
} from "../../utils/more/currency_country";
import { includesOnSearch } from "../../utils/more/search";

function CurrencyInput({
  width = "100%",
  label = "Escolha uma moeda",
  helperText,
  variant,
  sx = {},
  onChange = () => {},
  required,
  size,
  endAdornment,
  hiddenLabel,
  disableClearable,
  value,
  margin = "normal",
  readOnly,
  InputProps,
  fullWidth,
  symbolOnly,
}) {
  const [error, setError] = useState(false);

  const getPropCountry = useCallback(
    (code, prop) => {
      if (!code) return "";
      const selected = getCurrencyByCode(code);
      if (Boolean(selected)) {
        return selected[prop];
      }
    },
    []
  );

  const handleBlur = useCallback(() => {
    if (required && !value) {
      setError(true);
    }
  }, [required, value]);

  const handleFocus = useCallback(() => {
    setError(false);
  }, []);

  return (
    <Autocomplete
      options={CURRENCY_LIST}
      autoHighlight
      readOnly={readOnly}
      size={size}
      disableClearable={disableClearable}
      filterOptions={(options, state) =>
        options.filter((currency) =>
          includesOnSearch(state.inputValue, getCurrencySearchFields(currency))
        )
      }
      onBlur={handleBlur}
      onFocus={handleFocus}
      fullWidth
      sx={{ width: width, ...sx }}
      getOptionLabel={(option) =>
        symbolOnly ? option?.code : formatCurrencyLabel(option)
      }
      isOptionEqualToValue={(option, value) => option?.code === value?.code}
      value={
        value
          ? {
              code: value,
              symbol: getPropCountry(value, "symbol"),
              name: getPropCountry(value, "name"),
            }
          : null
      }
      onChange={(e, v) => {
        onChange(v ? v.code : "");
      }}
      renderOption={(props, option, { selected }) => (
        <MenuItem {...props} selected={selected}>
          {symbolOnly ? option.code : formatCurrencyLabel(option)}
        </MenuItem>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          margin={margin}
          error={error}
          required={required}
          hiddenLabel={hiddenLabel}
          helperText={error && helperText}
          slotProps={{
            input: {
              ...params.InputProps,
              sx: {
                fontWeight: "500",
              },
              endAdornment: (
                <React.Fragment>
                  {endAdornment}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
              ...InputProps,
            },
          }}
        />
      )}
    />
  );
}

export default CurrencyInput;
